import PropTypes from 'prop-types';
import React from 'react';
import S from 'modal.scss';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import { getMinLocalDate } from '../../../../../utils/dateUtils';

class ViewFlagModal extends React.Component {

  handleClose = () => this.props.onClose()

  render() {
    const { flag, active, deleteEnabled } = this.props;
    if (flag === null) return null;

    const flagTooltipText = this.props.flagTooltipText(flag);

    return (
      <Dialog
        active={active}
        className={S.modal}
        onEscKeyDown={this.handleClose}
        onOverlayClick={this.handleClose}
      >
        <IconButton
          icon="close"
          className={S.close}
          onClick={this.handleClose}
        />

        <h5 className={S.title}>{flag.name}</h5>
        <p>{flagTooltipText}</p>
        <p>{`${flag.user_name} on ${getMinLocalDate(flag.created_at)}`}</p>

        {
          deleteEnabled &&
          <Button
            label="Remove Flag"
            flat inverse ripple
            className={S.submit}
            onClick={() => this.props.onRemove()}
          />
        }
      </Dialog>
    );
  }
}

ViewFlagModal.propTypes = {
  active: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  deleteEnabled: PropTypes.bool.isRequired,
  flagTooltipText: PropTypes.func.isRequired,
  flag: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    suboption: PropTypes.string,
    note: PropTypes.string.isRequired,
    user_name: PropTypes.string.isRequired,
    created_at: PropTypes.string.isRequired,
  }),
};

ViewFlagModal.defaultProps = {
  active: false,
  deleteEnabled: false,
};

export default ViewFlagModal;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/components/viewFlagModal.jsx